/**
 * Variant Image Switcher para Simbiótico Íntimo
 * 
 * LÓGICA:
 * - Define window.pdpMaxImageIndex para limitar navegação do slider
 * - Remove últimas 2 imagens do DOM
 * - Troca SRC da primeira imagem baseado na variante
 * - Ao trocar variante, foca na primeira imagem
 */

(function () {
    'use strict';

    let variantImages = {};
    let lastVariant = null;
    let isInitialized = false;
    let originalTotal = 0;

    function isSimbiotico() {
        const productTitle = document.querySelector('.product__title h1, .product__title, [data-product-title]');
        if (productTitle) {
            const title = productTitle.textContent.toLowerCase();
            return title.includes('simbiótico') || title.includes('simbiotico');
        }
        return window.location.pathname.toLowerCase().includes('simbiotico');
    }

    function setupImages() {
        const mainImages = document.querySelectorAll('.pdp-images-track .container_main_pdp_images__image');
        originalTotal = mainImages.length;

        if (originalTotal < 3) {
            console.warn('[Variant Switcher] Menos de 3 imagens');
            return false;
        }

        // Salva URLs das imagens de variante ANTES de remover
        variantImages = {
            1: mainImages[0].src,
            2: mainImages[originalTotal - 2].src,
            3: mainImages[originalTotal - 1].src
        };

        // ATUALIZA o limite global ANTES de remover (N - 2 imagens = índice max = N - 3)
        window.pdpMaxImageIndex = originalTotal - 3;
        console.log('[Variant Switcher] Novo pdpMaxImageIndex:', window.pdpMaxImageIndex);

        // Remove as últimas 2 imagens principais
        mainImages[originalTotal - 2].remove();
        mainImages[originalTotal - 1].remove();

        // Remove thumbnails desktop
        const thumbnails = document.querySelectorAll('.pdp-thumbnails .pdp-thumbnail');
        if (thumbnails[originalTotal - 2]) thumbnails[originalTotal - 2].remove();
        if (thumbnails[originalTotal - 1]) thumbnails[originalTotal - 1].remove();

        // Remove blaze slides
        const blazeSlides = document.querySelectorAll('.blaze-track .blaze-slide');
        if (blazeSlides[originalTotal - 2]) blazeSlides[originalTotal - 2].remove();
        if (blazeSlides[originalTotal - 1]) blazeSlides[originalTotal - 1].remove();

        console.log('[Variant Switcher] Imagens removidas. Total visível:', originalTotal - 2);
        return true;
    }

    function getVariantNumber(text) {
        if (!text) return 1;
        const match = text.match(/(\d+)/);
        return match ? parseInt(match[1], 10) : 1;
    }

    function activateFirstImage() {
        // Ativa a primeira imagem/thumbnail em todos os contextos
        document.querySelectorAll('.pdp-images-track .container_main_pdp_images__image').forEach((img, i) => {
            img.classList.toggle('active', i === 0);
        });

        document.querySelectorAll('.pdp-thumbnails .pdp-thumbnail').forEach((thumb, i) => {
            thumb.classList.toggle('active', i === 0);
        });

        document.querySelectorAll('.blaze-track .blaze-slide').forEach((slide, i) => {
            slide.classList.toggle('active', i === 0);
        });

        // Scroll track para início
        const track = document.querySelector('.pdp-images-track');
        if (track) track.scrollLeft = 0;
    }

    function switchToVariant(variantNumber) {
        if (lastVariant === variantNumber) return;
        lastVariant = variantNumber;

        const newSrc = variantImages[variantNumber];
        if (!newSrc) return;

        // Salva scroll
        const scrollX = window.pageXOffset || window.scrollX;
        const scrollY = window.pageYOffset || window.scrollY;

        // Troca SRC da primeira imagem em todos os lugares
        const firstMain = document.querySelector('.pdp-images-track .container_main_pdp_images__image:first-child');
        if (firstMain) firstMain.src = newSrc;

        const firstThumb = document.querySelector('.pdp-thumbnails .pdp-thumbnail:first-child img');
        if (firstThumb) firstThumb.src = newSrc;

        const firstBlaze = document.querySelector('.blaze-track .blaze-slide:first-child img');
        if (firstBlaze) firstBlaze.src = newSrc;

        // Foca na primeira
        activateFirstImage();

        // Restaura scroll
        requestAnimationFrame(() => window.scrollTo(scrollX, scrollY));

        console.log('[Variant Switcher] Variante', variantNumber, 'aplicada');
    }

    function handleVariantEvent(e) {
        const target = e.target;
        let variantText = null;

        if (target.type === 'radio') {
            const label = document.querySelector(`label[for="${target.id}"]`);
            variantText = label ? label.textContent : target.value;
        } else if (target.tagName === 'LABEL' || target.closest('label')) {
            const label = target.tagName === 'LABEL' ? target : target.closest('label');
            variantText = label.textContent;
        } else if (target.tagName === 'SELECT') {
            variantText = target.options[target.selectedIndex]?.text;
        }

        if (variantText) {
            setTimeout(() => switchToVariant(getVariantNumber(variantText)), 50);
        }
    }

    function setupListeners() {
        document.addEventListener('change', handleVariantEvent, true);
        document.addEventListener('click', handleVariantEvent, true);
    }

    function getInitialVariant() {
        const checked = document.querySelector('input[type="radio"]:checked');
        if (checked) {
            const label = document.querySelector(`label[for="${checked.id}"]`);
            return getVariantNumber(label ? label.textContent : checked.value);
        }
        const select = document.querySelector('select[name="id"]');
        if (select && select.selectedIndex >= 0) {
            return getVariantNumber(select.options[select.selectedIndex].text);
        }
        return 1;
    }

    function init() {
        if (isInitialized) return;
        if (!isSimbiotico()) {
            console.log('[Variant Switcher] Não é Simbiótico');
            return;
        }

        console.log('[Variant Switcher] Inicializando...');

        setTimeout(() => {
            if (!setupImages()) return;
            setupListeners();

            const initial = getInitialVariant();
            console.log('[Variant Switcher] Variante inicial:', initial);
            lastVariant = null;
            switchToVariant(initial);

            isInitialized = true;
        }, 800);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    document.addEventListener('shopify:section:load', () => {
        isInitialized = false;
        init();
    });
})();
